import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { useState } from "react";
import { Grid, Button, Divider, Typography, Paper, Dialog, ListItem, makeStyles, Create, DialogFranchiseUser, Clear, AddCircleIcon, AccountCircleIcon, DialogFranchise, PipelineCharts, ProjectCharts } from "../../../../";
var useStyles = makeStyles(function (theme) {
  var _leftMain;

  return {
    root: {
      display: "flex",
      "justify-content": "space-between"
    },
    leftMain: (_leftMain = {}, _defineProperty(_leftMain, theme.breakpoints.up("md"), {
      boxShadow: "15px 0 15px -5px #333"
    }), _defineProperty(_leftMain, "padding", "24px"), _defineProperty(_leftMain, "height", "100%"), _defineProperty(_leftMain, "overflowY", "scroll"), _leftMain),
    headerLeftMain: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    },
    dataContact: {
      margin: "10px",
      display: "flex",
      "flex-direction": "column",
      "align-items": "left"
    },
    contact: {
      background: "#ededed45",
      borderRadius: "4px"
    },
    headerContact: {
      display: "flex",
      "align-items": "center",
      justifyContent: "space-between"
    },
    actionsContact: {
      display: "flex",
      justifyContent: "flex-end",
      "max-width": "86%"
    },
    divider: {
      margin: "20px 0",
      height: "4px"
    },
    mr30: {
      margin: "30px"
    },
    icon: {
      width: "80px",
      height: "auto"
    },
    contactsUser: {
      display: "flex",
      overflowY: "scroll",
      height: "400px",
      "flex-direction": "column",
      "align-items": "left",
      "justify-content": "flex-start"
    },
    edit: {
      color: theme.palette.pending.main
    },
    header: {
      display: "flex",
      "flex-direction": "row",
      "justify-content": "space-between",
      "align-items": "center"
    },
    people_actions: {
      display: "flex",
      "& button": {
        "min-width": "30px"
      },
      flexDirection: "column",
      alignItems: "flex-end"
    },
    text_wrap: {
      "word-wrap": "break-word"
    },
    cards: {
      display: "flex",
      "justify-content": "space-around",
      width: "80%",
      margin: "0 15px 25px"
    },
    card: {
      minHeight: "200px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "40%"
    },
    content: {
      width: "40%",
      "text-align": "center",
      margin: "20px"
    },
    cardText: {
      background: "#b7b6b682",
      width: "100%",
      minHeight: "200px",
      alignItems: "center",
      justifyContent: "center",
      display: "flex",
      borderRadius: "0 4px 4px 0"
    },
    charts: {
      display: "flex",
      "justify-content": "space-around",
      width: "80%",
      padding: "40px"
    }
  };
});

var FranchiseSingleDashboard = function FranchiseSingleDashboard(_ref) {
  var franchise = _ref.franchise,
      editFranchise = _ref.editFranchise,
      deleteFranchise = _ref.deleteFranchise,
      editUser = _ref.editUser,
      createUser = _ref.createUser,
      translation = _ref.translation,
      opportunities = _ref.opportunities,
      projects = _ref.projects,
      taxes = _ref.taxes,
      props = _objectWithoutProperties(_ref, ["franchise", "editFranchise", "deleteFranchise", "editUser", "createUser", "translation", "opportunities", "projects", "taxes"]);

  // console.log("entro en FranchiseSingleDashboard", franchise);
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      openEditFranchise = _useState2[0],
      setOpenEditFranchise = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      openUser = _useState4[0],
      setOpenUser = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      openDeleteFranchise = _useState6[0],
      setOpenDeleteFranchise = _useState6[1];

  var _useState7 = useState(""),
      _useState8 = _slicedToArray(_useState7, 2),
      variant = _useState8[0],
      setVariant = _useState8[1];

  var _useState9 = useState({
    users: [{
      name: "",
      email: ""
    }]
  }),
      _useState10 = _slicedToArray(_useState9, 2),
      users = _useState10[0],
      setUsers = _useState10[1];

  var openOpportunities = opportunities.filter(function (opp) {
    return opp.statusSells < 4;
  });
  var totalBudget = openOpportunities.reduce(function (acc, opp) {
    return acc + opp.budget;
  }, 0); // const [deletedUser, setDeleteUser] = useState({});
  // const [openDeleteUser, setOpenDeleteUser] = useState(false);

  var classes = useStyles();

  var handleDialogUser = function handleDialogUser() {
    setOpenUser(!openUser);
  };

  var handleCreateUser = function handleCreateUser(values) {
    return createUser(values);
  };

  var handleEditUser = function handleEditUser(user) {
    setVariant("edit");
    setUsers({
      users: [user]
    });
  }; // const handleDeleteUser = (user) => {
  // 	setDeleteUser(user);
  // };
  // const handleDialogDeleteUser = () => {
  // 	setOpenDeleteUser(!openDeleteUser);
  // };


  var handleDialogEditFranchise = function handleDialogEditFranchise() {
    setOpenEditFranchise(!openEditFranchise);
  };

  var handleDialogDeleteFranchise = function handleDialogDeleteFranchise() {
    setOpenDeleteFranchise(!openDeleteFranchise);
  }; // const handleDialogViewTask = (id) => {
  // 	if (!openViewTask) {
  // 		const task = tasks.find((task) => task._id === id);
  // 		setSelectedTask({
  // 			...task,
  // 			person_of_contact: task.contact._id
  // 		});
  // 	} else {
  // 		setSelectedTask({});
  // 	}
  // 	setViewTaskOpen(!openViewTask);
  // };
  // const handleItemDatatablePopover = (item, id) => {
  // 	if (item === 'view') handleDialogViewTask(id);
  // 	// } else if (item === "edit") {
  // 	//   handleDialogEditTask(id);
  // 	// } else if (item === "delete") {
  // 	//   handleDialogDeleteTask(id);
  // 	// }
  // };


  return [/*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.root
  }, /*#__PURE__*/React.createElement(DialogFranchise, {
    open: openEditFranchise,
    onClose: handleDialogEditFranchise,
    variant: "edit",
    taxes: taxes,
    translation: translation ? translation.dialogs.edit_contact : null,
    data: franchise,
    editFranchise: editFranchise
  }), /*#__PURE__*/React.createElement(DialogFranchiseUser, {
    open: openUser,
    onClose: handleDialogUser,
    variant: variant,
    users: users,
    editUser: editUser,
    translation: translation ? translation.dialogs.add_person_of_contact : null,
    createUser: handleCreateUser
  }), /*#__PURE__*/React.createElement(Dialog, {
    open: openDeleteFranchise,
    onClose: handleDialogDeleteFranchise,
    id: "modal-confirm-delete-contact" // title={translation.dialogs.delete_contact.titles.delete_contact}
    // text={translation.dialogs.delete_contact.info}
    // submit={translation.dialogs.delete_contact.buttons.delete}
    // cancel={translation.dialogs.delete_contact.buttons.cancel}
    ,
    title: "Disable franchise",
    text: "\xBFEstas seguro de desactivar la franquicia? Sus usuarios dejar\xE1n de tener acceso.",
    submit: "Delete",
    cancel: "Cancel",
    buttonColorSubmit: "secondary",
    buttonVariantSubmit: "contained",
    onCancel: handleDialogDeleteFranchise,
    buttonColorCancel: "secondary",
    buttonVariantCancel: "outlined",
    onSubmit: function onSubmit() {
      deleteFranchise();
      handleDialogDeleteFranchise();
    }
  }), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 3,
    xs: 12,
    style: {
      paddingBottom: "10px",
      height: "100vh"
    }
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.leftMain
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.headerContact
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.headerLeftMain
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, franchise ? franchise.name : "")), /*#__PURE__*/React.createElement("div", {
    className: classes.actionsContact
  }, /*#__PURE__*/React.createElement(Button, {
    "data-cy": "edit-franchise",
    className: classes.edit,
    color: "default",
    variant: "text",
    onClick: handleDialogEditFranchise
  }, /*#__PURE__*/React.createElement(Create, null)), /*#__PURE__*/React.createElement(Button, {
    "data-cy": "delete-franchise",
    color: "secondary",
    variant: "text",
    onClick: handleDialogDeleteFranchise
  }, /*#__PURE__*/React.createElement(Clear, null)))), /*#__PURE__*/React.createElement(Divider, {
    className: classes.divider
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.dataContact
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "primary",
    className: classes.text_wrap
  }, translation ? translation.contact_info.titles.contact_type : "Subcriptions", " "), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "primary",
    className: classes.text_wrap
  }, translation ? translation.contact_info.titles.contact_type : "Office: "), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: classes.text_wrap
  }, franchise.subscriptions && franchise.subscriptions.office365), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "primary",
    className: classes.text_wrap
  }, translation ? translation.contact_info.titles.contact_type : "Mailbox: "), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: classes.text_wrap
  }, franchise.subscriptions && franchise.subscriptions.mailbox)), /*#__PURE__*/React.createElement(Divider, {
    className: classes.divider
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.header
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "primary"
  }, translation ? translation.contact_info.people_of_contact.titles.people_of_contact : "Franchise users"), /*#__PURE__*/React.createElement(Button, {
    className: classes.add,
    color: "default",
    variant: "text",
    onClick: function onClick() {
      setVariant("add");
      handleDialogUser();
    },
    "data-cy": "add-user"
  }, /*#__PURE__*/React.createElement(AddCircleIcon, null))), /*#__PURE__*/React.createElement("div", {
    className: classes.contactsUser
  }, franchise && franchise.users ? franchise.users.map(function (person) {
    return person && /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: "8px"
      }
    }, /*#__PURE__*/React.createElement(ListItem, {
      className: classes.contact
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      justify: "center",
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 2
    }, /*#__PURE__*/React.createElement(AccountCircleIcon, null)), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 8,
      style: {
        display: "flex",
        flexDirection: "column"
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: classes.text_wrap
    }, person.name), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      className: classes.text_wrap
    }, person.email)), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 2,
      className: classes.people_actions
    }, /*#__PURE__*/React.createElement(Button, {
      className: classes.add,
      color: "default",
      variant: "text",
      onClick: function onClick() {
        handleEditUser(person);
        handleDialogUser();
      },
      "data-cy": "edit-user"
    }, /*#__PURE__*/React.createElement(Create, null))))));
  }) : null))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 9,
    xs: 12
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    style: {
      justifyContent: "space-evenly"
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 5,
    className: classes.cards
  }, /*#__PURE__*/React.createElement(PipelineCharts, {
    pipeline: openOpportunities,
    totalBudget: totalBudget,
    translation: translation ? translation : null,
    locale: franchise && franchise.country
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 5,
    className: classes.cards
  }, /*#__PURE__*/React.createElement(ProjectCharts, {
    projects: projects,
    translation: translation ? translation : null,
    locale: franchise && franchise.country
  })))))];
};

export { FranchiseSingleDashboard };